import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import Reveal from "@/components/Reveal";
import { ACCOMMODATIONS } from "@/lib/site";

export default function AccommodationGrid({ limit, heading = true }) {
  const items = limit ? ACCOMMODATIONS.slice(0, limit) : ACCOMMODATIONS;
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32" data-testid="accommodation-grid">
      {heading && (
        <Reveal className="max-w-2xl mb-16 md:mb-20">
          <div className="overline">Stay with us</div>
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight mt-4">
            Five ways to wake up <em className="italic font-light">slowly</em>.
          </h2>
          <p className="mt-6 text-sa-ink2 text-base sm:text-lg leading-relaxed">
            Whether you're rolling in with a 24-foot caravan or pitching a single tent, Shady Acres offers mostly shaded sites, all within an easy stroll of the pool and surrounding bushland.
          </p>
        </Reveal>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-16">
        {items.map((a, i) => (
          <Reveal key={a.id} delay={i * 80}>
            <Link to={`/book?package=${a.id}`} className="group flex flex-col gap-6" data-testid={`acc-card-${a.slug}`}>
              <div className="overflow-hidden rounded-2xl aspect-[4/3] w-full bg-sa-bg2 relative">
                {a.badge && (
                  <span className="absolute top-4 left-4 z-10 bg-sa-bg/90 text-sa-ink text-[11px] tracking-[0.2em] uppercase px-3 py-1.5 rounded-full">
                    {a.badge}
                  </span>
                )}
                <img
                  src={a.image}
                  alt={a.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                />
              </div>
              <div className="flex items-start justify-between gap-6">
                <div>
                  <h3 className="font-serif text-2xl sm:text-3xl tracking-tight">{a.name}</h3>
                  <p className="mt-2 text-sa-ink2 text-[15px] leading-relaxed max-w-md">{a.blurb}</p>
                  {a.note && (
                    <p className="mt-2 text-sa-ink2/70 text-[12px] italic leading-relaxed max-w-md" data-testid={`acc-note-${a.slug}`}>
                      {a.note}
                    </p>
                  )}
                  <div className="mt-3 text-sm text-sa-ink2">{a.sleeps}</div>
                </div>
                <div className="text-right shrink-0">
                  <div className="font-serif text-2xl text-sa-ink">
                    <span className="text-sm font-sans text-sa-ink2 mr-1">from</span>${a.price_from}<span className="text-sm">/night</span>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2 text-sa-accent group-hover:gap-3 transition-all">
                <span className="text-sm tracking-wide">Book now</span>
                <ArrowRight size={16} weight="bold" />
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
